import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueBootstrapToasts from "vue-bootstrap-toasts";
import VueSweetalert2 from 'vue-sweetalert2';
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import "../src/design/app.scss";
import Flutterwave from  'flutterwave-vue-v3'
import store from '@/state/store'
import App from './App.vue'
import tinymce from 'vue-tinymce-editor'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueGeolocation from 'vue-browser-geolocation';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
// import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'

// Vue.use(Buefy)
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.use(VueGeolocation);
Vue.component('qr-code', VueQRCodeComponent)
Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(Flutterwave, { publicKey: 'FLWPUBK-111b52a88a4a2a901eba1919bf5244ff-X' } )
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueBootstrapToasts);
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
